var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 520,
    viewBox: "0 0 275 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26491 140.176L9.26469 140.176C6.48753 144.224 5 149.018 5 153.928V200.689C5 214.118 15.8894 225 29.3184 225H81.4771C89.387 225 95.7955 231.409 95.7955 239.31V550.689C95.7955 564.118 106.685 575 120.114 575H245.682C259.11 575 270 564.118 270 550.69V29.3106C270 15.8821 259.111 5 245.682 5H114.834C106.818 5 99.3166 8.9492 94.7809 15.5574L94.7806 15.5578L9.26491 140.176Z",
    stroke: "#226CCD",
    strokeOpacity: 0.1,
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.ec69599b85472470cad96586770f5ae9.svg";
export { ForwardRef as ReactComponent };